import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import AppSourceListPage from '../pages/AppSourceListPage';
import AppSourceFormPage from '../pages/AppSourceFormPage';
import TransactionReportPage from '../pages/TransactionReportPage';
import DefaultFarePage from '../pages/DefaultFarePage';
import AppLayout from '../components/Layout/AppLayout';
import AuditTrailPage from '../pages/AuditTrailPage';
import TransactionLogPage from '../pages/TransactionLogPage';
import DailyReportPage from '../pages/DailyReportPage';
import UniqueUserPage from '../pages/UniqueUserPage';

function RequireAuth() {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}

function RedirectIfAuthenticated() {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  if (user) {
    const redirectTo = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}

const AppRoutes = () => (
  <Routes>
    <Route element={<RedirectIfAuthenticated />}>
      <Route path="/login" element={<LoginPage />} />
    </Route>
    <Route element={<RequireAuth />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/app-sources" element={<AppSourceListPage />} />
        <Route path="/app-sources/new" element={<AppSourceFormPage mode="create" />} />
        <Route path="/app-sources/:id/edit" element={<AppSourceFormPage mode="edit" />} />
        <Route path="/default-fare" element={<DefaultFarePage />} />
        <Route path="/transaction-log" element={<TransactionLogPage />} />
        <Route path="/daily-report" element={<DailyReportPage />} />
        <Route path="/unique-user" element={<UniqueUserPage />} />
        <Route path="/reports/transaction-detail" element={<TransactionReportPage />} />
        <Route path="/audit-trail" element={<AuditTrailPage />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default AppRoutes;
